export default [
    {
        path: 'exportacao',
        component: () => import(/* weimunizacaockChunkName: 'imunizacao-exportacao' */ '@/views/imunizacao/exportacao/Index'),
        redirect: 'exportacao/index',
        children: [
            {
                name: 'imunizacao-exportacao-index',
                path: 'index',
                component: () => import(/* weimunizacaockChunkName: 'imunizacao-exportacao' */ '@/views/imunizacao/exportacao/List.vue'),
            },
            {
                name: 'imunizacao-exportacao-create',
                path: 'create',
                component: () => import(/* weimunizacaockChunkName: 'imunizacao-exportacao' */ '@/views/imunizacao/exportacao/Form.vue'),
            },
            {
                name: 'imunizacao-exportacao-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(/* weimunizacaockChunkName: 'imunizacao-exportacao' */ '@/views/imunizacao/exportacao/Form.vue'),
            },
        ],
    },
]